// src/components/client-portal/PortalLoading.jsx
// The navy waiting screen (spec 4.1). Two callers:
//   - ClientPortal, while the open call is in flight or the portal fonts are still loading (spec 8.3).
//     The page has already called usePortalDocument itself, so this one passes enabled: false.
//   - App.js, while Firebase auth answers on #/portal (spec 3.8). Nothing else has painted the document
//     yet, so standalone makes this screen do it.
import SoloScreen from "./SoloScreen";
import Lockup from "./Lockup";
import usePortalDocument from "./usePortalDocument";
import { PORTAL_BASE_TITLE } from "../../utils/portalNav";

export default function PortalLoading({ standalone = false }) {
  usePortalDocument({ mode: "solo", title: PORTAL_BASE_TITLE, enabled: standalone });
  return (
    <SoloScreen screen="loading">
      <Lockup />
      <p className="eyebrow">Your Private Client Portal</p>
      <p className="fine" role="status">
        One moment, please.
      </p>
    </SoloScreen>
  );
}
